const TYPE_SECURITY = {
  Ninguno: 'Ninguno',
  'TLS/STARTTLS': 'TLS/STARTTLS',
  SSL: 'SSL',
};
export const TYPE_SECURITY_SELECT = [
  { name: TYPE_SECURITY.Ninguno, value: TYPE_SECURITY.Ninguno },
  { name: TYPE_SECURITY['TLS/STARTTLS'], value: TYPE_SECURITY['TLS/STARTTLS'] },
  { name: TYPE_SECURITY.SSL, value: TYPE_SECURITY.SSL },
];
